import { render } from "./SurveyImprovementHeader.vue?vue&type=template&id=1790be6e"
import script from "./SurveyImprovementHeader.vue?vue&type=script&lang=js"
export * from "./SurveyImprovementHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__